var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"pr-lg-1",attrs:{"xs12":""}},[_c('AccountChart',{attrs:{"type":_vm.type}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }